module.exports = __webpack_public_path__ + "static/media/send.4d2f227d.svg";